import { useMemo } from "react";

import { LoadingCircle } from "../..";
import { SearchFloatArea } from "../SearchFloatArea";
import { SEARCH_FLOAT_OPTIONS_ROW_CLASS_NAME } from "./const";
import { SearchFloatOptionsProps } from "./type";

export const SearchFloatOptions = ({
  isOpen = false,
  isLoading,
  options,
  floatAreaFooter,
  onSelectOption,
}: SearchFloatOptionsProps) => {
  const optionsUI = useMemo(() => {
    if (isLoading) {
      return (
        <div className="flex w-full items-center justify-center py-[10px]">
          <LoadingCircle className="animate-spin" />
        </div>
      );
    }

    if (!options?.length) {
      return <div className="flex w-full items-center justify-center py-[10px]">検索結果がありません</div>;
    }

    return (
      <div className="flex flex-col overflow-hidden">
        <div className="flex-1 overflow-auto">
          {options?.map(({ patientNo, patientName, patientId, birthDate }) => (
            <div
              key={patientNo}
              className={SEARCH_FLOAT_OPTIONS_ROW_CLASS_NAME({
                disable: false,
                active: false,
              })}
              onClick={() => {
                onSelectOption?.({ patientNo, patientName, patientId, birthDate });
              }}
            >
              <span>{patientNo}</span>
              <span className="ml-[14px]">{patientName}</span>
              <span className="ml-[18px]">({birthDate})</span>
            </div>
          ))}
        </div>
        {floatAreaFooter}
      </div>
    );
  }, [floatAreaFooter, isLoading, onSelectOption, options]);

  if (!isOpen) return null;

  return <SearchFloatArea>{optionsUI}</SearchFloatArea>;
};
